<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Subcontas</h5>
      <BButton
        v-if="hasPermission('adicionar_subcontas')"
        variant="primary"
        class="d-flex align-items-center"
        @click="irParaCadastro"
      >
        <i class="bi bi-plus-circle-fill mr-2" title="Nova Subconta"></i>
      </BButton>
    </div>

    <!-- Filtros -->
    <div class="d-flex mb-3" style="gap: 10px;">
      <input
        v-model="filters.nome"
        placeholder="Filtrar por Nome"
        class="form-control same-height"
        @input="filtrar"
      />
      <b-button
        variant="secondary"
        @click="limparFiltros"
        class="d-flex align-items-center justify-content-center"
      >
        <i class="bi bi-funnel mr-2" title="Limpar Filtros"></i>
        <!-- Limpar -->
      </b-button>
    </div>

    <!-- Tabela nativa com ordenação -->
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>
            <button class="btn btn-link p-0" @click="sort('nome')">
              Nome {{ arrow('nome') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('plano_de_contas')">
              Plano de Contas {{ arrow('plano_de_contas') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('tipo')">
              Tipo {{ arrow('tipo') }}
            </button>
          </th>
          <!-- <th>Descrição</th> -->
          <th>
            <button class="btn btn-link p-0" @click="sort('ativo')">
              Status {{ arrow('ativo') }}
            </button>
          </th>
          <th class="text-end">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in items" :key="row.id">
          <td>{{ row.nome }}</td>
          <td>{{ row.plano_de_contas }}</td>
          <td>
            <span :class="row.tipo === 'Receita' ? 'text-primary' : 'text-danger'">
              {{ row.tipo }}
            </span>
          </td>
          <!-- <td>{{ row.descricao }}</td> -->
          <td>{{ row.ativo ? 'Ativo' : 'Inativo' }}</td>
          <td class="text-end">
            <router-link
              v-if="hasPermission('detalhar_subcontas')"
              :to="`/financeiro/subcontas/${row.id}/detalhar`"
            >
              <i class="bi bi-eye-fill text-primary mx-2" title="Detalhar"></i>
            </router-link>
            <router-link
              v-if="hasPermission('alterar_subcontas')"
              :to="`/financeiro/subcontas/${row.id}`"
            >
              <i class="bi bi-pencil-fill text-warning mx-2" title="Editar"></i>
            </router-link>
            <i
              v-if="hasPermission('excluir_subcontas')"
              class="bi bi-trash-fill text-danger mx-2"
              @click="excluir(row.id)"
              title="Excluir"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginação -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <!-- resumo -->
      <div>
        Mostrando {{ startRow }} a {{ endRow }} de {{ totalItems }} registros
      </div>

      <!-- seletor de itens por página -->
      <div class="d-flex align-items-center" style="gap: .5rem;">
        <b-form-select
          v-model="limit"
          :options="pageOptions.map(n => ({ value: n, text: n + ' / página' }))"
          size="sm"
          style="width: 6rem"
        />
      </div>

      <!-- controle de página -->
      <div class="d-flex align-items-center">
        <b-pagination
          v-model="page"
          :per-page="limit"
          :total-rows="totalItems"
          size="sm"
          limit="5"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useSortableTable } from '@/utils/useSortableTable';
import { usePermissions } from '@/composables/usePermissions';
import { BButton, BFormSelect, BPagination } from 'bootstrap-vue-next';
import axios from '@/services/axios';

const router = useRouter();
const { fetchPermissions, hasPermission } = usePermissions();

// composable de tabela
const {
  items,
  totalItems,
  page,
  limit,
  filters,
  sort,
  arrow,
  load,
} = useSortableTable('/financeiro/subcontas', { key: 'nome', order: 'asc' });

// inicializa filtro de nome
Object.assign(filters.value, { nome: '' });

// opções de limite de página
const pageOptions = [10, 15, 20, 25, 50];

// computeds para resumo
const startRow = computed(() =>
  (page.value - 1) * limit.value + 1
);
const endRow = computed(() =>
  Math.min(page.value * limit.value, totalItems.value)
);

// watchers para recarregar ao mudar página ou limite
watch(page, () => load());
watch(limit, () => {
  page.value = 1;
  load();
});

// ações de navegação e CRUD
function irParaCadastro() {
  router.push('/financeiro/subcontas/novo');
}
// function detalhar(id) {
//   router.push(`/financeiro/subcontas/${id}/detalhar`);
// }
// function editar(id) {
//   router.push(`/financeiro/subcontas/${id}`);
// }
async function excluir(id) {
  if (!confirm('Confirma exclusão desta subconta?')) return;
  try {
    await axios.delete(`/financeiro/subcontas/${id}`);
    load();
    alert('Subconta excluída');
  } catch (e) {
    alert(e.response?.data?.error || 'Erro ao excluir');
  }
}

// filtros e paginação local
function filtrar() {
  page.value = 1;
  load();
}
function limparFiltros() {
  page.value = 1;
  filters.value.nome = '';
  load();
}

onMounted(async () => {
  await fetchPermissions();
  load();
});
</script>

<style scoped>
.same-height { height: 30px; }

:deep(.pagination.pagination-sm .page-link) {
  padding: rem rem;
  line-height: 1;
  font-size: 0.8rem !important;
  border-radius: 0 !important;
}

</style>
